module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"location":"Месторасположение","status":"Статус"},"en":{"location":"Location","status":"Status"}}')
  delete Component.options._Ctor
}
